import { render, staticRenderFns } from "./tnc2.vue?vue&type=template&id=562b3048&"
import script from "./tnc2.vue?vue&type=script&lang=js&"
export * from "./tnc2.vue?vue&type=script&lang=js&"
import style0 from "./tnc2.vue?vue&type=style&index=0&id=562b3048&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports